import { useFormik } from "formik"

export function useTasksFiltersFormik() {
  const formik = useFormik({
    initialValues: {
      name: "",
      state: "active",
      billable: undefined,
      users: [],
      groups: [],
      section_status: "active",
      tags: [],
    },
    onSubmit: (values) => {},
  })

  return formik
}
